
export const CustomSelectorSize = {
    DEFAULT: 'default',
    LITTLE: 'little',
}

export const CustomSelectorType = {
    CHECKBOX: 'checkbox',
    RADIO: 'radio',
}


// WEBPACK FOOTER //
// ./web/js/components/customCheckbox/constants.js